import React, {Component, Fragment} from 'react';
import {BASE_URL, PAGE_OPEN_TYPE} from "../../../configuration";
import iconCalc from "../../../assets/img/calculator.png";
import {FormattedMessage} from "react-intl";
import PCBVideo from "./PCBVideo/PCBVideo";
import Video from "../../../assets/video/home-video.mp4";
import InformationNotice from "./InformationNotice/InformationNotice";
import ResponsiveInformationNotice from "./ResponsiveInformationNotice";
import {Link} from 'react-router-dom';

class ResponsiveHomeContent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            quotationPcb: {
                orderType: 1,
                fileKey: "",
                pcbParam: {
                    materialDetails: 0,
                    panelFlag: 0,
                    edgeRails: 0,
                    layer: 2,
                    length: 100,
                    width: 100,
                    qty: 5,
                    thickness: 1.6,
                    impedance: 1,
                    pcbColor: 0,
                    surfaceFinish: 0,
                    copperWeight: 1,
                    goldFinger: 0,
                    panelByJLCPCB_X: 0,
                    panelByJLCPCB_Y: 0,
                    differentDesign: 1,
                    flyingProbe: 1,
                    castellatedHoles: 0,
                    silkColor: 1,
                    orderDetailsRemark: ""

                },
                smtStencilParam: {
                    dimensionsID: 112,
                    stencilQty: 1,
                    electropolishing: 0,
                    fiducials: 0,
                    customizeFlag: 0,
                    customizeSizeX: 0,
                    customizeSizeY: 0,
                    customizeSize: 0,
                    stencilSide: 0,
                    orderRemark: "",
                    framework: 0
                }
            },
            quotationStencil: {
                orderType: 3,
                fileKey: "",
                pcbParam: {
                    materialDetails: 0,
                    panelFlag: 0,
                    edgeRails: 0,
                    layer: 2,
                    length: 100,
                    width: 100,
                    qty: 5,
                    thickness: 1.6,
                    impedance: 1,
                    pcbColor: 0,
                    surfaceFinish: 0,
                    copperWeight: 1,
                    goldFinger: 0,
                    panelByJLCPCB_X: 0,
                    panelByJLCPCB_Y: 0,
                    differentDesign: 1,
                    flyingProbe: 1,
                    castellatedHoles: 0,
                    silkColor: 1,
                    orderDetailsRemark: ""

                },
                smtStencilParam: {
                    dimensionsID: 112,
                    stencilQty: 1,
                    electropolishing: 0,
                    fiducials: 0,
                    customizeFlag: 0,
                    customizeSizeX: 0,
                    customizeSizeY: 0,
                    customizeSize: 0,
                    stencilSide: 0,
                    orderRemark: "",
                    framework: 0
                }
            }
        };
        this.toPcbQuotationHomePageService = this.toPcbQuotationHomePageService.bind(this);
        this.toStencilQuotationHomePageService = this.toStencilQuotationHomePageService.bind(this);
    }

    toPcbQuotationHomePageService = (event) => {
        localStorage.setItem("fromNavi", 2);
        localStorage.setItem("type", 1);
        localStorage.setItem("type1q", JSON.stringify(this.state.quotationPcb));


        // window.location.replace(BASE_URL + 'quotation/pcb')
        // window.open(BASE_URL + 'quotation/pcb', '_self')
    };

    toStencilQuotationHomePageService = (event) => {
        localStorage.setItem("fromNavi", 2);
        localStorage.setItem("type", 3);
        localStorage.setItem("type3q", JSON.stringify(this.state.quotationStencil));

        // window.location.replace(BASE_URL + 'quotation/stencil')
        // window.open(BASE_URL + 'quotation/stencil', '_self')
    };

    render() {
        return (
            <Fragment>
                <div className="home-responsive-content">
                    <p className="responsive-home-heading">
                        世界最安水準です、1枚から量産価格！
                    </p>
                    <p>
                        {/*<a onClick={this.toPcbQuotationHomePageService}>*/}
                        <Link to="/quotation/pcb"
                              target={PAGE_OPEN_TYPE}
                              onClick={()=>{
                                  localStorage.setItem("fromNavi", 2);
                                  localStorage.setItem("type", 1);
                                  localStorage.setItem("type1q", JSON.stringify(this.state.quotationPcb));
                              }}
                        >
                            <div className="col-md-12 section-btn1 text-center cursor-point-change">

                                <div className="col-md-6 cursor-point-change">
                                    <span className="responsive-btn-caption">基板製造見積スタート</span>
                                </div>
                            </div>
                            {/*</a>*/}
                        </Link>
                    </p>
                    <hr/>
                    <p className="responsive-home-heading">
                        表面実装で必要な冶具もご一緒に！
                    </p>
                    <p>
                        {/*<a onClick={this.toPcbQuotationHomePageService}>*/}
                        <Link to="/quotation/stencil"
                              target=""
                              onClick={()=>{
                                  localStorage.setItem("fromNavi", 2);
                                  localStorage.setItem("type", 3);
                                  localStorage.setItem("type3q", JSON.stringify(this.state.quotationStencil));
                              }}
                        >
                            <div className="col-md-12 section-btn2 text-center cursor-point-change">

                                <div className="col-md-6 cursor-point-change">
                                    <span className="responsive-btn-caption">メタルマスク製造見積スタート</span>
                                </div>

                            </div>
                            {/*</a>*/}
                        </Link>
                    </p>
                    <hr/>
                    <p className="responsive-home-heading">
                        お申し込みはネットで完結！
                    </p>
                    <p className="responsive-home-content">
                        24時間365日いつでもお申し込みいただけます。
                    </p>
                    <p className="responsive-home-content">
                        ウェブサイトでのお申し込みからご契約成立までの流れです。
                    </p>
                    <video className="responsive-video" controls loop muted>
                        <source src={Video} type="video/mp4"/>
                    </video>
                    <hr/>

                </div>
                <div className="registration-div-responsive">
                    <p className="responsive-home-heading">
                        そのアイデアをカタチに！
                    </p>
                </div>
                <div className="registration-div-responsive-content">
                    <p className="responsive-home-heading">
                        {/*簡単無登録はこちら*/}
                        簡単登録はこちら
                    </p>
                    <p>
                        {/*<a href={KEYCLOAK_REGISTRATION_URL}>*/}
                        {/*    <div className="col-md-12 section-btn1 text-center cursor-point-change">*/}

                        {/*        <div className="col-md-6 cursor-point-change">*/}
                        {/*            <span className="responsive-btn-caption">新規登録</span>*/}
                        {/*        </div>*/}

                        {/*    </div>*/}
                        {/*</a>*/}
                    </p>
                    <p className="responsive-home-heading">
                        世界最安水準です、今すぐお見積！
                    </p>
                    <p>
                        <Link to="/quotation/pcb"
                              target=""
                              onClick={()=>{
                                  localStorage.setItem("fromNavi", 2);
                                  localStorage.setItem("type", 1);
                                  localStorage.setItem("type1q", JSON.stringify(this.state.quotationPcb));
                              }}
                        >

                            <div className="col-md-12 section-btn2 text-center cursor-point-change">

                                <div className="col-md-6 cursor-point-change">
                                    <span className="responsive-btn-caption">世界最大級の試作基板工場</span>
                                </div>

                            </div>
                        </Link>

                    </p>
                </div>

                <div className="registration-div-responsive">
                    <p className="responsive-home-heading">
                        アカウントをお持ちの方
                    </p>
                </div>
                <div className="registration-div-responsive-content-1">
                    <p className="responsive-home-heading">
                        注文状況、進捗状況の確認へ
                    </p>
                    <p>
                        <Link to="/login">
                            <div className="col-md-12 section-btn1 text-center cursor-point-change">

                                <div className="col-md-6 cursor-point-change">
                                    <span className="responsive-btn-caption">マイページログイン</span>
                                </div>

                            </div>
                        </Link>
                    </p>

                </div>
                <hr/>
                <div className="home-responsive-content">
                    <p className="responsive-home-heading">
                        インフォメーション
                    </p>
                    <p>
                        <ResponsiveInformationNotice/>
                    </p>
                </div>
            </Fragment>
        );
    }

}

export default ResponsiveHomeContent;



// WEBPACK FOOTER //
// ./src/components/Site/HomeContent/ResponsiveHomeContent.js